import {SET_ONLINE} from '../reducers/general';

export function setOnline(online) {
  return {
    type: SET_ONLINE,
    online
  };
}
